module.exports = __webpack_public_path__ + "img/dk-k.bf7b1167.png";